import { FC } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { AIAgent } from 'features/ai/ai-agent'
import { GameEventProvider } from 'features/game/event-context'
import { GameProvider } from 'features/game/game-context'

import { BuyBoardGame } from './buy-board-game'
import { ContactUs } from './contact-us'
import { Game } from './game'
import { HowToPlay } from './how-to-play'
import { LandingPage } from './landing'
import { Login } from './login'
import { Play } from './play'
import { PlayerProfile } from './player-profile'
import { PlayerStats } from './player-stats'
import { ProtectedRoute } from './protected-route'

const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'how-to',
        element: <HowToPlay />,
      },
      {
        path: 'buy',
        element: <BuyBoardGame />,
      },
      {
        path: 'contact',
        element: <ContactUs />,
      },
      {
        index: true,
        element: (
          <ProtectedRoute>
            <Play />
          </ProtectedRoute>
        ),
      },
      {
        path: 'play',
        element: (
          <ProtectedRoute>
            <Play />
          </ProtectedRoute>
        ),
      },
      {
        path: 'player',
        element: (
          <ProtectedRoute>
            <PlayerProfile />
          </ProtectedRoute>
        ),
      },
      {
        path: 'stats',
        element: (
          <ProtectedRoute>
            <PlayerStats />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: 'play/:gameId',
    element: (
      <ProtectedRoute>
        <GameProvider>
          <GameEventProvider>
            <AIAgent>
              <Game />
            </AIAgent>
          </GameEventProvider>
        </GameProvider>
      </ProtectedRoute>
    ),
  },
])

export const Router: FC = () => <RouterProvider router={router} />
